import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import { isLoaded, isEmpty } from 'react-redux-firebase';
import PageLoader from '@components/PageLoader/PageLoader';
import { authSelector } from '@selectors/firebase';
import { userDataSelector, appKeysSelector } from '@selectors/global';
import { get, size, isUndefined, isNull, split, toLower } from 'lodash';
import { rootRouteDetector } from '@utils/routeDetector';
import { SUBSCRIPTION_TYPES } from '../../constants';
import { isMobile } from 'react-device-detect';
import { setCookie } from '@utils/cookie-methods';

const updateSmartLook = (carrier_name, dot_number, email, user_id) => {
  if(window.smartlook){
    var id = size(email) > 0 ? email : user_id;
    var config = {
      email,
      dot_number,
      carrier_name
    };
    window.smartlook('consentAPI', 'true');
    window.smartlook('consentForms', 'true');
    window.smartlook('consentIP', 'true');
    window.smartlook('identify', id, config);
  }
}

const AuthorizedRoute = props => {
  const authLoaded = isLoaded(props.auth);
  const authorized = !isEmpty(props.auth);
  const { render, userData, keys, ...rest } = props;

  if (authLoaded && authorized) {
    const dot_number = get(userData, 'claims.carrier_dot_number', '');
    const carrier_name = get(userData, 'claims.carrier_name', '');
    const email_address = get(userData, 'claims.user_email', '');
    const user_id = get(userData, 'claims.user_id', '');
    const first_name = get(userData, 'claims.user_first_name', '');
    const last_name = get(userData, 'claims.user_last_name', '');
    const name = `${first_name} ${last_name}`.trim();
    const intercomKey = keys.get('intercom');
    const routeTest = rootRouteDetector('/d');
    const isStaff = get(userData, 'claims.is_staff', false);
    const is_paid_active = get(userData, 'claims.is_paid_active', false);
    const subscriptionTypeNonDenormalized = get(
      userData,
      'claims.subscription_type',
    );
    const subscriptionType =
      !isNull(subscriptionTypeNonDenormalized) &&
      !isUndefined(subscriptionTypeNonDenormalized)
        ? get(SUBSCRIPTION_TYPES, subscriptionTypeNonDenormalized)
        : subscriptionTypeNonDenormalized;
    if(!isStaff){
      updateSmartLook(carrier_name, dot_number, email_address, user_id);
    }
    if (
      !isMobile &&
      size(intercomKey) > 0 &&
      !isStaff &&
      is_paid_active === true
    ) {
      const config = {
        app_id: intercomKey,
        email: email_address,
        name,
        user_id,
        company: {
          id: dot_number,
          name: carrier_name,
          dot_number: dot_number,
          subscriptionType,
          is_paid_active,
        },
      };
      window.intercomSettings = config;
      window.Intercom('boot', config);
      localStorage.setItem('is-intercom-booted', 'true');
      if (routeTest) {
        window.Intercom('update', { hide_default_launcher: true });
      }
    } else {
      localStorage.setItem('is-intercom-booted', 'false');
    }
  }

  const renderHelper = childProps => {
    const path = get(childProps, ['match', 'path']);
    return !authLoaded ? (
      <PageLoader />
    ) : authorized ? (
      render(childProps)
    ) : (
      loginRedirectAcl(path)
    );
  };

  const extractCompnayKeyFromURL = () => {
    const paths = split(window.location.pathname, '/');
    return size(paths) > 2 ? paths[2] : '';
  };

  const loginRedirectAcl = path => {
    if (path === '/d') {
      const companyKey = extractCompnayKeyFromURL();
      setCookie('companyKey', toLower(companyKey), 10);

      if(size(companyKey) > 0){
        return <Redirect to={`/auth/partner/${companyKey}/login`} />;
      }
      return <Redirect to="/auth/partner/login" />;
    }
    return <Redirect to="/auth/login" />;
  };

  return <Route render={renderHelper} {...rest} />;
};

AuthorizedRoute.propTypes = {
  render: PropTypes.func,
  auth: PropTypes.object,
  userData: PropTypes.object,
  keys: PropTypes.object,
};

const mapStateToProps = createStructuredSelector({
  auth: authSelector,
  userData: userDataSelector,
  keys: appKeysSelector,
});

export default connect(
  mapStateToProps,
  null,
)(AuthorizedRoute);
